import Stomp, { Client } from "@stomp/stompjs";
import { useEffect, useState } from "react";
import api from "./api";
import { useGlobal } from "./GlobalContext";
import unescape from "unescape";

function LoginPage() {
  const [email, setEmail] = useState("");
  const [stompClient, setStompClient] = useState(null);
  const [isVerifying, setIsVerifying] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [accessToken, setAccessToken] = useState(null);
  const [time, setTime] = useState(null);
  const [timer, setTimer] = useState(null);
  const { hl } = useGlobal();

  useEffect(() => {
    if(time === null && timer !== null) {
      clearInterval(timer);
      setTimer(null);
      stompClient.deactivate();
    }
    if(stompClient !== null && stompClient.webSocket !== null && time !== null && time % 30 === 0) {
      stompClient.webSocket.send("");
    }
  }, [time]);

  async function subscribe(channelId) {
    if(stompClient !== null) {
      try {
        await stompClient.deactivate();
      }
      catch(e) {
        console.log(e);
      }
    }
    const client = new Client({
      brokerURL: "wss://api.exorehab.com/ws",
      // heartbeatIncoming: 30,
      // heartbeatOutgoing: 30
    });
    setStompClient(client);
    client.onConnect = (frame) => {
      client.subscribe("/sub/verification/email/" + channelId, async (message) => {
        setTime(null);
        await getToken(message.body);
      });
    }
    client.onDisconnect = (frame) => {
      setIsVerifying(false);
    }
    client.activate();
  }

  async function sendVerificationEmail() {
    if(!isVerifying) {
      setIsVerifying(true);
      setIsSending(true);
      setTime(300);
      let res;
      try {
        res = await api.POST(`/auth/verification/email/request?address=${encodeURIComponent(email)}&language=${hl}`);
      }
      catch(e) {
        console.log(e);
        setIsVerifying(false);
        setIsSending(false);
        return;
      }
      await subscribe(res.data.channelId);
      setIsSending(false);
      //TODO fix setTime
      const interval = setInterval(() => setTime((t) => {
        t--;
        if(t <= 0) {
          setIsVerifying(false);
          return null;
        }
        // if(t % 30 === 0) {
        //   console.log(stompClient);
        //   console.log(stompClient.webSocket);
        // }
        return t;
      }), 1000);
      setTimer(interval);
    }
  }

  async function getToken(authKey) {
    const rawBasic = email + ":" + authKey;
    const encodedBasic = btoa(unescape(rawBasic));
    let res;
    try {
      res = await api.GET("/auth/token?authType=email&clientType=web", { Authorization: `Basic ${encodedBasic}` });
    }
    catch(e) {
      console.log(e);
      return;
    }
    setAccessToken(res.data.accessToken);
  }

  async function deleteToken() {
    try {
      await api.DELETE("/auth/token", { Authorization: `Bearer ${accessToken}` });
    }
    catch(e) {
      console.log(e);
      return;
    }
    setAccessToken(null);
  }

  if(accessToken === null) {
    const buttonText = isSending ? "전송 중" : parseInt(time / 60) + ":" + (time % 60 >= 10 ? time % 60 : ("0" + time % 60));
    return (
      <div style={{ display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
        <div style={{ display: "flex", height: 25 }}>
          <input name="email" style={{ width: 180 }} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="이메일 주소" disabled={isVerifying} onKeyDown={async (e) => {
            if(e.code === "Enter") {
              await sendVerificationEmail();
            }
          }}/>
          <button style={{ width: 80 }} onClick={async () => await sendVerificationEmail()} disabled={isVerifying}>{isVerifying ? buttonText : "인증 요청"}</button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
      <div>
        <div>{`Access Token: ${accessToken}`}</div>
        <button style={{ width: 80 }} onClick={async () => await deleteToken()}>토큰 삭제</button>
      </div>
    </div>
  );
}

export default LoginPage;